import { type ChangeEvent, useCallback, useMemo, useState } from 'react'

interface DebitAmountCalculatorProps {
  transactionAmountCents: number
  initialEligibleAmountCents?: number
  eligibleAmountFieldName: string
  debitAmountFieldName: string
}

const formatCurrency = (dollars: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(dollars)
}

export default function DebitAmountCalculator ({
  transactionAmountCents,
  initialEligibleAmountCents,
  eligibleAmountFieldName,
  debitAmountFieldName,
}: DebitAmountCalculatorProps) {
  const [eligibleAmount, setEligibleAmount] = useState<string>(
    initialEligibleAmountCents != null ? (initialEligibleAmountCents / 100).toFixed(2) : ''
  )

  const debitAmountDollars = useMemo(() => {
    const eligibleAmountCents = Math.round((parseFloat(eligibleAmount) || 0) * 100)
    const debitAmountCents = Math.max(0, transactionAmountCents - eligibleAmountCents)
    return debitAmountCents / 100
  }, [eligibleAmount, transactionAmountCents])

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setEligibleAmount(e.target.value)
  }, [])

  return (
    <>
      <div className='flex flex-col my-2 gap-2'>
        <label htmlFor='eligible_amount_field' className='helper-text'>
          Eligible Amount
        </label>
        <input
          type='number'
          step={0.01}
          id='eligible_amount_field'
          name={eligibleAmountFieldName}
          value={eligibleAmount}
          onChange={handleChange}
          className='form-input'
        />
      </div>
      <div className='flex flex-col my-2 gap-2'>
        <label className='helper-text'>Debit Amount (Calculated)</label>
        <div className='text-gray-700 text-lg py-2'>
          {formatCurrency(debitAmountDollars)}
        </div>
        <input
          type='hidden'
          name={debitAmountFieldName}
          value={debitAmountDollars.toFixed(2)}
        />
      </div>
    </>
  )
}
